import React from 'react'

function Videos() {
  return (
    <div>Neither videos 😁😎</div>
  )
}

export default Videos